// CREATED BY ATHARVA SHAH & ISHANI MATHUR (PULKIT DWIVEDI & ABHINAV PANDEY TOO) FOR EXTC DEPARTMENT

export default [
  {
    name: "Dr. Shailaja Kurode ",
    designation: "Professor Emeritus",
    image:
      "https://i.ibb.co/sdShKtmZ/Whats-App-Image-2026-01-13-at-22-00-00.jpg",
    qualification: "PhD in Systems & Control from I.I.T. Bombay",
    experience: "38 Years",
    email:"shubhangi.verulkar@spit.ac.in",
    phone: "8149197915",
    url: "www.linkedin.com/in/shailaja-kurode-4958163b",
    scholar:
      "https://scholar.google.com/citations?user=4acVW-gAAAAJ&hl=en&authuser=1",
  },
 {
    name: "Dr. Y.S. Rao",
    designation: "Vice Principal, Professor",
    image: "https://i.ibb.co/MZ5ZRSH/PXL-20240510-055514850.jpg",
    qualification: "Ph.D. (IIT Bombay-ES)",
    experience: "30+ Years",
    expertise:
      "Embedded System, Digital Power Electronics, VLSI Design, Wireless Sensor Networks",
    email: "ysrao@spit.ac.in",
    phone: "(022) – 69846900 EXT: 980",
    url: "https://www.linkedin.com/in/dr-y-s-rao-4b223130/",
    scholar: "https://scholar.google.co.in/citations?user=Dd4Lv0cAAAAJ&hl=en",
  },
    {
    name: "Dr. Satyanarayana Bheesette",
    designation: "Professor of Practice",
    image: "https://i.ibb.co/Ny11ztr/satyanarayana-pic.png",
    qualification: "Ph.D. in Physics (IIT Bombay)",
    experience: "41+ Years",
    expertise: "",
    email: "bsn@spit.ac.in",
    phone: "+91 9987537702",
    url: "https://www.linkedin.com/in/satyanarayana-bheesette-ph-d-177a8519/",
    scholar: "https://scholar.google.com/citations?hl=en&user=ceeMQYMAAAAJ",
  },
  {
    name: "Dr. Deepa Chitre ",
    designation: "Professor of Practice",
    image:
      "https://www.spit.ac.in/wp-content/uploads/2026/02/Deepa-Chitre.jpeg",
    qualification: "Masters in Information Management (Mumbai University), BE Electronics (Mumbai University)",
    experience: "29 Years",
    email: "deepa.chitre@spit.ac.in",
    phone: "(022) – 69846900 EXT:",
    url: "https://www.linkedin.com/in/deepachitre?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    scholar:
      "-",
  },  
  {
    name: "Dr. Rajendra R Sawant",
    designation: "Professor, Electronics & Telecom",
    image: "https://i.ibb.co/n66zTtb/PXL-20240510-054742716.jpg",
    qualification: "PhD(IITB); MTech(IITB); BE(Elect.Engg)(GCoE, A’Bad, DBM)",
    experience: "30+ Years",
    expertise: "Power Electronics & Automation",
    email: "rajendra.sawant@spit.ac.in",
    phone: "(022) – 69846900",
    url: "https://in.linkedin.com/in/rrsawant",
    scholar: "https://scholar.google.com/citations?user=itbxS6oAAAAJ&hl=en",
  },
  {
    name: "Dr. Kiran Talele",
    designation:
      "Associate Professor & Dean-Students, Alumni & External Relations",
    image: "https://i.ibb.co/bRLghwX/IMG-21083.jpg",
    qualification: "PhD",
    experience: "35 Years",
    expertise:
      "Digital Signal & Image Processing, Computer Vision & Machine Learning",
    email: "kiran.talele@spit.ac.in",
    phone: "(022) – 69846900 EXT:",
    url: "https://www.linkedin.com/in/k-t-v-talele/",
    scholar: "https://scholar.google.com/citations?user=fP7xEcwAAAAJ&hl=en",
  },
  {
    name: "Dr. Reena Sonkusare",
    designation: "Associate Professor & HOD",
    image: "https://i.ibb.co/42Q75c5/PXL-20240510-055441933.jpg",
    qualification: "Ph.D(Mumbai University), MTech(IIT Bombay)",
    experience: "25 Years",
    expertise: "Mixed Signal VLSI Design, RF Antenna, Communication",
    email: "reena_kumbhare@spit.ac.in",
    phone: "(022) – 69846900 EXT: 382",
    url: "https://www.linkedin.com/in/dr-reena-sonkusare-kumbhare-67ab4581",
    scholar: "https://scholar.google.co.in/citations?user=_h55xlsAAAAJ&hl=en",
  },
  {
    name: "Dr. Sukanya A. Kulkarni",
    designation: "Associate Professor",
    image: "https://i.ibb.co/HHP3YNY/PXL-20240510-055128154.jpg",
    qualification: "Ph.D(Mumbai University)",
    experience: "30 Years",
    expertise: "RF & Wireless Communication",
    email: "sukanya_kulkarni@spit.ac.in",
    phone: "(022) – 69846900 EXT: 983",
    url: "https://www.linkedin.com/in/dr-sukanya-kulkarni-84160258",
    scholar: "https://scholar.google.co.in/citations?user=3g7cebcAAAAJ&hl=en",
  },
  {
    name: "Dr. Deepak C Karia",
    designation: "Associate Professor",
    image: "https://i.ibb.co/MpGsyyt/PXL-20240510-054630871.jpg",
    qualification: "Ph.D (Mumbai University)",
    experience: "22+ Years",
    expertise: "Communication, Networking",
    email: "deepak_karia@spit.ac.in",
    phone: "(022) – 69846900 EXT: 915",
    url: "www.linkedin.com/in/dr-deepak-c-karia-2998132a",
    scholar: "https://scholar.google.com/citations?user=Sntv9U4AAAAJ&hl=en",
  },
  {
    name: "Dr. Rajendra Sutar",
    designation: "Associate Professor",
    image: "https://i.ibb.co/3v4ZG8g/PXL-20240510-055725296.jpg",
    qualification: "M.E. PhD (VNIT)",
    experience: "25 Years",
    expertise:
      "Power Electronics, Biomedical Electronics, Electronic Circuits & Systems",
    email: "rajendra_sutar@spit.ac.in",
    phone: "(022) – 69846900 EXT: 950",
    url: "https://www.linkedin.com/in/dr-rajendra-sutar-4766b216/",
    scholar:
      "https://scholar.google.com/citations?user=HDwtyu0AAAAJ&hl=en&oi=ao",
  },
  {
    name: "Dr. Narendra Anant Bhagat",
    designation: "Associate Professor",
    image: "https://i.ibb.co/MZDXDqP/PXL-20240510-055414175.jpg",
    qualification: "Ph.D (Mumbai University), MTech (Mumbai University)",
    experience: "24 Years",
    expertise:
      "Analog & Digital VLSI Design, Digital Electronics & Microprocessors, Electrical Network, B.E.E.",
    email: "narendra_bhagat@spit.ac.in",
    phone: "(022) – 69846900 EXT: 953",
    url: "https://www.linkedin.com/in/",
    scholar: "https://scholar.google.co.in/citations?user=54Pbd6sAAAAJ&hl=en",
  },
  {
    name: "Prof. Manish M. Parmar",
    designation: "Associate Professor",
    image: "https://i.ibb.co/Vp1mb2x/PXL-20240510-054928376.jpg",
    qualification: "M.E. (IT), Pursuing PhD",
    experience: "33 Years",
    expertise:
      "Microprocessors, Computer Architecture, Embedded Systems, Computer Networks",
    email: "manish_parmar@spit.ac.in",
    phone: "(022) – 69846900 EXT: 952",
    url: "https://www.linkedin.com/in/manish-parmar-7812581a9/",
    scholar: "https://scholar.google.com/citations?user=1rJ-y4MAAAAJ&hl=en",
  },
  {
    name: "Dr. P. V. Kasambe",
    designation: "Assistant Professor",
    image: "https://i.ibb.co/D5YTBsB/PXL-20240510-060037933.jpg",
    qualification:
      "Ph.D Electronics (University of Mumbai), M.E. (Electronics, University of Mumbai)",
    experience: "24 Years",
    expertise: "VLSI, Optimization Algorithms, MEMS Sensor Design",
    email: "prashant_kasambe@spit.ac.in",
    phone: "(022) – 69846900 EXT:",
    url: "https://www.linkedin.com/in/dr-prashant-kasambe-064551ab/",
    scholar: "https://scholar.google.co.in/citations?hl=en&user=XcnPuZ4AAAAJ",
  },
  {
    name: "Dr. Anand D. Mane",
    designation: "Assistant Professor",
    image: "https://i.ibb.co/SttkcYf/PXL-20240510-055548389.jpg",
    qualification:
      "Ph.D (Mumbai University), M.E. (Communication Engineering, Electronics Engineering)",
    experience: "25 Years Teaching, 2 Years Industry",
    expertise: "Mobile Communication, Wireless Networks, Embedded Systems",
    email: "anand_mane@spit.ac.in",
    phone: "(022) – 69846900 EXT: 984",
    url: "",
    scholar:
      "https://scholar.google.com/citations?hl=en&view_op=list_works&gmla=AJsN-F7fkGkS-neqQ1mXn01SVeQD_DtUDQmBUh0DnDQm7h1Iu1cG6GlOhIN84iF-wodZg-Fc_MOs2RGF0jfVna5fFAApbLOkvOLxGHwtQ3CbBPr5fI_HbyfT4WUAIrAPmTzTMw5I8UuQ&user=RjPLx_sAAAAJ",
  },

  {
    name: "Dr. Payal Shah",
    designation: "Assistant Professor",
    image: "https://i.ibb.co/YBSmbQb/PXL-20240510-055856262.jpg",
    qualification: "Ph.D",
    experience: "17 Years",
    expertise:
      "Electronic Devices and Circuits, Analog VLSI Design, Neuromorphic Engineering",
    email: "payal_shah@spit.ac.in",
    phone: "(022) – 69846900 EXT:",
    url: "https://www.linkedin.com/in/payal-shah-59563353",
    scholar: "https://scholar.google.co.in/citations?hl=en&user=RvYzqJoAAAAJ",
  },
  {
    name: "Dr. Manisha Bansode",
    designation: "Assistant Professor",
    image: "https://i.ibb.co/c1hMYHg/IMG-20240511-WA0001.jpg",
    qualification: "Ph.D",
    experience: "17 Years",
    expertise:
      "Communication Engineering, Electronics circuit design, Image Processing",
    email: "manisha_bansode@spit.ac.in",
    phone: "(022) – 69846900 EXT: 956",
    url: "https://www.linkedin.com/in/manisha-r-bansode-3aa901162/",
    scholar:
      "https://scholar.google.com/citations?hl=en&user=9dj8JjoAAAAJ&view_op=list_works&authuser=1&gmla=AH70aAXvRklAj9CGH8g1LhSd-khENCO7l4NvSCkT8LLwdYds5c-37CVE3jsJ1QExyENrMEq93o8mM-yphFuGRKLU_95JsMuRt-gWTg",
  },
  {
    name: "Prof. G. T. Haldankar",
    designation: "Assistant Professor",
    image: "https://i.ibb.co/gSR7PN3/PXL-20240510-054657629.jpg",
    qualification: "M.E. Electronics (Pursuing Ph.D.)",
    experience: "13 Years",
    expertise: "Power Electronics",
    email: "g_haldankar@spit.ac.in",
    phone: "(022) – 69846900 EXT:",
    url: "https://www.linkedin.com/in/govind-haldankar-3b67111ab/",
    scholar: "https://scholar.google.co.in/citations?hl=en&user=Ve13BGsAAAAJ",
  },
  {
    name: "Prof. Milind Paraye",
    designation: "Assistant Professor",
    image: "https://i.ibb.co/RQYRMcj/Milind-Sir-photo-1.jpg",
    qualification: "M.E. (Pursuing Ph.D.)",
    experience: "14 Years",
    expertise: "Embedded Systems, PV solar, ML, AI",
    email: "milind_paraye@spit.ac.in",
    phone: "(022) – 69846900 EXT:",
    url: "",
    scholar:
      "https://scholar.google.com/citations?hl=en&view_op=list_works&gmla=AJsN-F7PDqlbLXpfuv6e53_47hzB9EDgkGo10XkqzC4LKIEH5zay6Gl_scT8XuWQJakV15TcY_eErbq_TtxhZ0tM-JI8HEwsuAhHva_LvASBSBUEaCOQF7yt4BG1ZGlWqHJM5TiIQ3OK&user=a9Oqav8AAAAJ",
  },
  {
    name: "Prof. Priya Deshpande",
    designation: "Assistant Professor",
    image: "https://i.ibb.co/hff5H0D/PXL-20240510-055242991.jpg",
    qualification: "M.Tech. (Pursuing Ph.D.)",
    experience: "10 Years",
    expertise: "Embedded System, Signal and Image Processing",
    email: "priya.chimurkar@spit.ac.in",
    phone: "(022) – 69846900 EXT: 355",
    url: "https://www.linkedin.com/in/priya-chimurkar-70013563",
    scholar: "https://scholar.google.co.in/citations?hl=en&user=j5VIEfEAAAAJ",
  },
  {
    name: "Prof. Najib Ghatte",
    designation: "Assistant Professor",
    image: "https://i.ibb.co/MRZqLNW/PXL-20240510-054908901.jpg",
    qualification: "B.E; M.E",
    experience: "10 Years",
    expertise:
      "Control System, Signals and Systems, Electronic Devices, Networks, 8051",
    email: "najib_ghatte@spit.ac.in",
    phone: "9821867642",
    url: "https://www.linkedin.com/in/najibghatte",
    scholar: "https://scholar.google.co.in/citations?hl=en&user=f62HrAEAAAAJ",
  },
  {
    name: "Prof. Pallavi Malame(Nair)",
    designation: "Assistant Professor",
    image: "https://i.ibb.co/VmMvFk5/PXL-20240510-055334032.jpg",
    qualification: "B.E; M.E (Pursuing Ph.D.)",
    experience: "9 Years",
    expertise:
      "Antennas & Microwave Engineering, Electromagnetics, Dielectric Spectroscopy",
    email: "pallavi_malame@spit.ac.in",
    phone: "(022) – 69846900 EXT: 361",
    url: "linkedin.com/in/pallavimalame",
    scholar: "https://scholar.google.co.in/citations?user=cX92W04AAAAJ&hl=en",
  },
  {
    name: "Dr. Amol S Deshpande",
    designation: "Assistant Professor",
    image: "https://i.ibb.co/HBK9XFS/PXL-20240510-054950234.jpg",
    qualification: "PhD, Post-Doc",
    experience: "9 Years",
    expertise: "High Voltage Engineering, Image Processing",
    email: "amol_deshpande@spit.ac.in",
    phone: "(022) – 69846900 EXT:",
    url: "https://www.linkedin.com/in/amol-deshpande-b495829",
    scholar: "https://scholar.google.com/citations?hl=en&user=D7TQKXSAAAAJ",
  },
  {
    name: "Prof. Sneha A. Weakey",
    designation: "Assistant Professor",
    image: "https://i.ibb.co/BNcNXzN/sneha-maam-pic3.png",
    qualification: "M.Tech (Control System)",
    experience: "6 Years",
    expertise: "Control Systems, Digital Circuits, Electronics Devices",
    email: "sneha_15weakey@spit.ac.in",
    phone: "(022) – 69846900 EXT:",
    url: "https://www.linkedin.com/in/sneha-weakey",
    scholar:
      "https://scholar.google.com/citations?user=NA08SMQAAAAJ&hl=en&oi=ao",
  },
  {
    name: "Dr. Shanti Swamy",
    designation: "Assistant Professor",
    image: "https://i.ibb.co/18bndfd/shanti-swamy-pic2.png",
    qualification: "Ph.D.",
    experience: "28 Years",
    email: "shanti.swamy@spit.ac.in",
    phone: "(022) – 69846900 EXT:",
    url: "https://www.linkedin.com/in/dr-shanti-swamy-55b25a14/",
    scholar: "https://scholar.google.co.in/citations?user=FxKdFxAAAAAJ&hl=en",
  },
  {
    name: "Dr.Shubhangi M. Verulkar",
    designation: "Assistant Professor",
    image:
      "https://i.ibb.co/hJc75V39/Whats-App-Image-2025-11-10-at-08-54-36-1.jpg",
    qualification: "P.h.D-Electronics,ME-EXTC,BE-Electronics",
    experience: "18 Years",
    email: "shubhangi.verulkar@spit.ac.in",
    phone: "(022) - 69846900 EXT:",
    url: "",
    scholar: "https://scholar.google.com/citations?hl=en&user=kkRucIAAAAAJ",
  },

];
